import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetAllUsersUseCaseInterface,
  GetUserByIdUseCaseInterface,
} from 'domain/usecases';

interface IAdministratorsState {
  administratorsListData: GetAllUsersUseCaseInterface.Result;
  selectedAdministratorData: Omit<
    GetUserByIdUseCaseInterface.Result,
    'password'
  >;
}

interface IPayloadAdministratorsListData
  extends PayloadAction<GetAllUsersUseCaseInterface.Result> {}

interface IPayloadSelectedAdministratorData
  extends PayloadAction<GetUserByIdUseCaseInterface.Result> {}

const initialState: IAdministratorsState = {
  administratorsListData: null,
  selectedAdministratorData: null,
};

export const AdministratorsSlice = createSlice({
  name: 'administrators-slice',
  initialState,
  reducers: {
    loadAdministratorsListData: (
      state,
      action: IPayloadAdministratorsListData,
    ) => {
      state.administratorsListData = action.payload;
    },
    clearAdministratorsListData: (state) => {
      state.administratorsListData = null;
    },
    loadSelectedAdministratorData: (
      state,
      action: IPayloadSelectedAdministratorData,
    ) => {
      state.selectedAdministratorData = action.payload;
    },
    clearSelectedAdministratorData: (state) => {
      state.selectedAdministratorData = null;
    },
  },
});

export const {
  loadAdministratorsListData,
  clearAdministratorsListData,
  loadSelectedAdministratorData,
  clearSelectedAdministratorData,
} = AdministratorsSlice.actions;

export default AdministratorsSlice.reducer;
